interface SecondDescriptionProps {
  brk?: any;
  data: any;
}

export const SecondDescription = ({ brk, data }: SecondDescriptionProps) => {
  return (
    <>
      <p className="con-internet" style={{ fontSize: "14px" }}>
        {data.name}
      </p>
      {brk && <br />}

      <ul style={{ marginLeft: "14px", fontSize: "13px" }}>
        {data.use.map((el: any, i: number) => {
          return <li key={i}>{el}</li>;
        })}
      </ul>
    </>
  );
};
